import LogNames from 'txp-data/lib/schema/telemetry/LogNames';
import TxpEntitiesState from 'txp-data/lib/schema/innerSchema/TxpEntitiesState';

/**
 * populate the TXP error card dataPoint object
 */

export default function populateErrorCardDataPoint(
    entityNamesMap: number,
    txpEntitiesState: TxpEntitiesState
) {
    return {
        [LogNames.entityNamesMap]: entityNamesMap ? entityNamesMap.toString() : null,
        [LogNames.endState]: txpEntitiesState ? TxpEntitiesState[txpEntitiesState] : null,
    };
}
